import { group, Layer } from './frame';
import { PRIM_CAPSULE, PRIM_DISK, type Primitive } from './sdf/primitives';

// Seven-segment seat numbers remain legible without loading a font into either renderer.
const DIGITS = ['bc', 'abged', 'abgcd', 'fgbc', 'afgcd', 'afgecd', 'abc', 'abcdefg'];
const SEGMENTS: Record<string, number[]> = {
  a: [-0.3, 0.5, 0.3, 0.5], b: [0.3, 0.5, 0.3, 0], c: [0.3, 0, 0.3, -0.5],
  d: [-0.3, -0.5, 0.3, -0.5], e: [-0.3, 0, -0.3, -0.5], f: [-0.3, 0.5, -0.3, 0], g: [-0.3, 0, 0.3, 0],
};

/** A seat badge above effects, with a minimum screen size on wide arenas. */
export function playerMarker(x: number, headTop: number, slot: number, color: string, zoom: number) {
  const r = Math.max(0.25, 9 / Math.max(8, zoom)), y = headTop + r * 1.5 + 0.1;
  const disk = (radius: number): Primitive => ({ kind: PRIM_DISK, ax: x, ay: y, bx: x, by: y, r: radius });
  const cap = (ax: number, ay: number, bx: number, by: number, radius: number): Primitive => ({ kind: PRIM_CAPSULE, ax, ay, bx, by, r: radius });
  const pointer = [cap(x - r * 0.4, y - r, x, y - r * 1.4, r * 0.12), cap(x, y - r * 1.4, x + r * 0.4, y - r, r * 0.12)];
  const digit = [...(DIGITS[slot] ?? DIGITS[0]!)].map((key) => {
    const [ax, ay, bx, by] = SEGMENTS[key]!;
    return cap(x + ax! * r, y + ay! * r, x + bx! * r, y + by! * r, r * 0.075);
  });
  return [
    group([disk(r * 1.13), ...pointer], '#ffffff', Layer.Overlay, { style: 'flat' }),
    group([disk(r)], color, Layer.Overlay, { style: 'flat' }),
    group([disk(r * 0.78)], '#151d29', Layer.Overlay, { style: 'flat' }),
    group(digit, '#ffffff', Layer.Overlay, { style: 'flat' }),
  ];
}
